import useNotificationSimpleFormFieldsRules from './useNotificationSimpleFormFieldsRules'
export default useNotificationSimpleFormFieldsRules
